export const formatPrice = (val: string | number, unit = true) => {
  const num: number = +val || 0;
  return (
    (unit ? 'THB ' : '') +
    num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  );
};
export const formatNumber = (val: string, decimal = 0) => {
  return Number(val) === 0 ? '-' : Number(val).toFixed(decimal);
};

export const stripHtmlTags = (str: string = '') => {
  return str.replace(/<[^>]*>/g, '');
};

export const formatDateFull = (date: string | number | Date) => {
  const _date = new Date(date);
  return _date.toLocaleDateString('th-TH', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export const formatTel = (input: string, stripDash = false) => {
  let digits = input;

  if (!digits.startsWith('0')) {
    digits = `0${digits}`;
  }

  let extension = '';

  // find extension
  const parts = input.split('-');
  if (parts.length > 1) {
    const lastPart = parts[parts.length - 1];
    if (lastPart.length <= 3 && /^\d+$/.test(lastPart)) {
      extension = lastPart;
      digits = parts.slice(0, -1).join('-');
    }
  }

  digits = digits.replace(/[^\d]/g, '');

  const mainNumber = digits.substring(0, 10);

  let formattedNumber = '';

  if (mainNumber.startsWith('02')) {
    // Bangkok numbers: 02-XXXXXXX
    const remaining = mainNumber.substring(2);
    formattedNumber = `02-${remaining}`;
  } else {
    // Other area codes: 0XX-XXXXXXX
    if (mainNumber.length >= 10) {
      formattedNumber = `${mainNumber.substring(0, 3)}-${mainNumber.substring(3)}`;
    } else if (mainNumber.length >= 6) {
      formattedNumber = `${mainNumber.substring(0, 3)}-${mainNumber.substring(3)}`;
    } else {
      formattedNumber = mainNumber;
    }
  }

  if (stripDash) {
    return digits;
  }

  if (extension) {
    formattedNumber += `-${extension}`;
  }

  return formattedNumber;
};
